<ng-container *transloco="let convert;">
  <div>
    @if (!ambassadors || ambassadors.length === 0) {
      <h3 data-test-id="authorized-ambassadors-empty-state-title" style="text-align:center">
        {{ convert('ambassadorAuthorization.headers.noAmbassadorAuthorization') }}
      </h3>
    }
    @if (ambassadors && ambassadors.length !== 0) {
      <app-legacy-table [columns]="columns" [cardConfig]="cardConfig">
        @for (row of ambassadors; track row; let i = $index) {
          <table-row-group>
            <table-row [columns]="columns" [row]="row">
              <table-cell *appTableCell="let row; column: 'name'" [attr.data-test-id]="'authorized-ambassadors-table-name-cell-' + i" (click)="toggleDrawer(i)">
                <div
                  allytm-click-tagged="false"
                  aria-hidden="true"
                  class="btn btn-link name-column"
                >{{ row?.name }}</div>
              </table-cell>
              <table-cell *appTableCell="let row; column: 'phone'">
                <div class="cell">
                  {{ row?.phone ? reformatPhone(row?.phone) : '' }}
                </div>
              </table-cell>
              <table-cell *appTableCell="let row; column: 'email'">
                <div class="cell">{{ row?.email }}</div>
              </table-cell>
              <table-cell *appTableCell="let row; column: 'dateAuthorized'">
                <div class="cell"> {{ formatDate(row?.authorized) }} </div>
              </table-cell>
              <table-cell *appTableCell="let row; column: 'actions'">
                <button
                  [attr.data-test-id]="'authorized-ambassadors-table-remove-button-' + i"
                  allytmln="remove"
                  class="btn btn-link"
                  (click)="openModal(row)"
                >{{ convert('ambassadorAuthorization.btnLabels.remove') }}</button>
              </table-cell>
            </table-row>
            <table-row [row]="row" [expandable]="true" #drawer>
              <table-cell *appTableCell="let row; colSpan: columns.length">
                <div class="container drawer">
                  <h4 [attr.data-test-id]="'authorized-ambassadors-drawer-name-' + i">{{ row?.name }}</h4>
                  {{ row?.comment }}
                  <button
                    [attr.data-test-id]="'authorized-ambassadors-drawer-close-button-' + i"
                    data-track-elem="icon"
                    allytmln="drawerClose"
                    class="drawer__close"
                    [attr.aria-label]="convert('common.btnClose')"
                    (click)="closeDrawer(i)"
                    >
                    <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                  </button>
                </div>
              </table-cell>
            </table-row>
          </table-row-group>
        }
      </app-legacy-table>
    }
  </div>
  <app-remove-authorized-ambassador-modal
    [modalId]="'remove-authorize-ambassador-modal'"
    (ambassadors)="setNewAuthorizedAmbassadors($event)"
    (success)="showSuccess($event)"
    (error)="ambassadorResponseModalComponent.show()"
  ></app-remove-authorized-ambassador-modal>
  <app-ambassador-response-modal
    [modalId]="'ambassador-response-modal'"
  ></app-ambassador-response-modal>
</ng-container>
